import axios from 'axios';
import authHeader from '@/services/auth.header';
import { HTTP } from '@/http/config'; 
import { AnyObject } from 'yup';
const API_URL = HTTP.api_url;
class PermissionService{
    async getRolHasPermission(rolId):Promise<AnyObject>{    
        const response = await axios.get(API_URL + 'roles/list-permission', 
        { 
            params: {id:rolId},
            headers: authHeader() 
        })
         .then(response => {                   
           return response.data;
         }).catch(error => {
           const response = JSON.stringify(error.response.data)
           console.log(response)      
           return response
         });
         return  response;
        }  

        async getInfoRol(rolId):Promise<AnyObject>{    
        const response = await axios.get(API_URL + 'roles/info-rolAuth', 
        { 
            params: {id:rolId},
            headers: authHeader() 
        })
         .then(response => {                   
           return response.data;
         }).catch(error => {
           const response = JSON.stringify(error.response.data)
           console.log(response)      
           return response
         });
         return  response;
        } 

         async getAllPermission():Promise<AnyObject>{    
        const response = await axios.get(API_URL + 'roles/list-allPermission', { headers: authHeader() })
         .then(response => {                   
           return response.data;
         }).catch(error => {
           const response = JSON.stringify(error.response.data)
           console.log(response)      
           return response
         });
         return  response;
        } 
        async postUpdatePermission(id,permission):Promise<AnyObject> {    
          const response = await axios.put(API_URL + `roles/${id}`,  
            {id:Number(id),permission:[...permission]},     
            { headers: authHeader() },      
          )
          .then(response =>{
            //console.log(response.data)
            return response?.data;
          })
          .catch(error=>{
            const dataError = error.response.data
            console.log(dataError)   
            return dataError;
          });
          return response;
        }
}
export default new PermissionService()